import { useEffect, useState } from 'react';
import { Line } from '@ant-design/plots';
import { formatarReal } from '../functions/funcoes';
import { iVendas } from '../interfaces/iVendas';
import { Typography, Flex } from 'antd';
import { getHeight } from '../functions/funcoes';
import { Preto, Vendas } from '../constants/Cores';

const { Text } = Typography;

const CtVendasDiaria = () => {
  const [dados, setDados] = useState<iVendas[]>([]);

  useEffect(() => {
    window.addEventListener('vendasDelphi', (event: any) => {
      const dadosRecebidos = event.detail;
      setDados(dadosRecebidos);
    });
  }, []);


  function getAltura() {
    let AAltura = {
      A1920xL1080: 180,
      A1680xL1050: 180,
      A1600xL900: 149,
      A1440xL900: 149,
      A1400xL1050: 149,
      A1366xL768: 130,
      A1280xL1024: 149,
      A1280xL960: 149,
      A1280xL800: 139,
      A1280xL768: 139,
      A1280xL720: 139,
      A1280xL600: 139,
      A1152xL864: 139,
      A1024xL768: 138,
      A800xL600: 138,
    };

    return getHeight(AAltura);
  }

  const Total = dados.reduce((total, d) => total + d.valor, 0);
  const QtdeVendas = dados.reduce((total, d) => total + d.qtdevendas, 0);
  let TkMedio = 0;
  if (Total !== 0) {
    TkMedio = Total / QtdeVendas
  }
  const config = {
    data: dados,
    height: getAltura(),
    autoFit: true,
    autoResize: true,
    xField: 'data',
    yField: 'valor',
    paddingBottom: 5,
    axis: {
      y: {
        tick: false,
        labelFill: Preto,
        labelFontWeight: 600,
        labelFormatter: (d: any) => (formatarReal(d)),
      }
    },
    interaction: {
      tooltip: {
        marker: false,
      },
    },
    style: {
      lineWidth: 2,
      maxWidth: 200,
    },
    label: false,
    scale: {
      y: { nice: true },
      color: {
        domain: ['valor'],
        range: Vendas
      },
    },
    tooltip: {
      channel: 'y',
      name: 'Total',
      valueFormatter: (d: any) => (formatarReal(d))
    },
  };
  return (
    <>
      <Line {...config} />
      <Flex
        gap='small'
        justify='center'>
        <Text>Total: {formatarReal(Total)} | Vendas: {QtdeVendas} | Tk médio: {formatarReal(TkMedio)}</Text>
      </Flex>
    </>
  )

};

export default CtVendasDiaria;